import React from "react";
import styled from "styled-components";

const SeparateContainer = ({ style, children }) => {
  return <Container style={style}>{children}</Container>;
};

export default SeparateContainer;

const Container = styled.div`
  border: 1px solid var(--surface-300);
  border-radius: 8px;
  overflow-x: auto;
  width: 100%;
`;
